module.exports = __webpack_public_path__ + "89d1d2ab649dd9e49405ee6783bfca98.svg";